package gr.tech.site.components.sections

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Resize
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.disabled
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaApple
import com.varabyte.kobweb.silk.components.icons.fa.FaWindows
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.site.styles.*
import gr.tech.site.util.isABear
import gr.tech.site.util.reformatDate
import kotlinx.browser.document
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.*


@Composable
private fun RequiredLabel(forId: String, text: String) {
    Label(forId = forId, attrs = FormInputLabelStyle.toModifier().toAttrs()) {
        Text(text)
        Span(attrs = Modifier.color(Colors.Red).margin(left = 2.px).toAttrs()) { Text("*") }
    }
}

@Composable
fun SalesforceContactForm(leadSource: String, state: String, util: String) {
    // Since Salesforce likes to bitch about specific date field type, but then asks for a text field.
    // Going to use Input.Date type, take its value, parse it into a format salesforce accepts, plug the value back into
    // -the correct field's value attribute. Best of both worlds! Just more work.
    var selectedStartDate by remember { mutableStateOf("") }
    var selectedCompletionDate by remember { mutableStateOf("") }
    var formLock by remember { mutableStateOf(true) }

    var url by remember { mutableStateOf("https://websubmitfrontend.com/api/submit-new-contact.php") }
    val webToUrl by remember { mutableStateOf("https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=") }
    val myorgid by remember { mutableStateOf("00DHp000001scIw") }

    Form(
        action = url,
        attrs = Modifier
            .fillMaxWidth()
            .id("input-form")
            .toAttrs {
                attr("method", "POST")
                disabled(formLock)
                onSubmit { event ->
                    val form = event.currentTarget as HTMLFormElement
                    event.preventDefault()

                    val firstName = (document.getElementById("first_name") as HTMLInputElement).value
                    val lastName = (document.getElementById("last_name") as HTMLInputElement).value
                    val email = (document.getElementById("email") as HTMLInputElement).value
                    val phone = (document.getElementById("phone") as HTMLInputElement).value
                    val company = (document.getElementById("company") as HTMLInputElement).value
                    val projectName = (document.getElementById("00NVb000003bMcX") as HTMLInputElement).value
                    val street = (document.getElementById("street") as HTMLTextAreaElement).value
                    val city = (document.getElementById("city") as HTMLInputElement).value
                    val state = (document.getElementById("state") as HTMLInputElement).value
                    val zip = (document.getElementById("zip") as HTMLInputElement).value
                    val utilityProvider = (document.getElementById("00NVb000003bMJB") as HTMLInputElement).value
                    val projectType = (document.getElementById("00NVb000001wlIv") as HTMLSelectElement).value
                    val startDate = (document.getElementById("00NVb000003bM4f") as HTMLInputElement).value
                    val endDate = (document.getElementById("00NVb000003bM7t") as HTMLInputElement).value
                    val buildingType = (document.getElementById("00NVb000003bMW5") as HTMLSelectElement).value
                    val roomAmount = (document.getElementById("00NVb000003bNS9") as HTMLInputElement).value

                    // Weird method to get multiple options
                    val roomUse = (document.getElementById("00NVb000003bOHl") as HTMLSelectElement) // Get the element
                    val selectedRoomUses = (0 until roomUse.selectedOptions.length) // Iterate over the selected options
                        .mapNotNull { roomUse.selectedOptions.item(it) as? HTMLOptionElement } // Grab the selected items as an optionHelement to map its value.
                        .map { it.value }
                    val roomUseString = selectedRoomUses.joinToString(", ")

                    val roomDetails = (document.getElementById("00NVb000003bPQj") as HTMLTextAreaElement).value
                    val quantityProducts = (document.getElementById("00NVb000003bOo1") as HTMLTextAreaElement).value
                    val quantityDesired = (document.getElementById("00NVb000003bHpn") as HTMLTextAreaElement).value
                    val dehuHvac = (document.getElementById("00NVb000003bQ0D") as HTMLSelectElement).value
                    val additionalDetails = (document.getElementById("00NVb000003bQcv") as HTMLTextAreaElement).value

                    val conversionForm = document.getElementById("00NVb000003d57l") as HTMLTextAreaElement
                    //conversionForm.value = ""

                    conversionForm.value = """
                        First name: $firstName
                        Last name: $lastName
                        Email: $email
                        Phone: $phone
                        Company: $company
                        Project name: $projectName
                        Street: $street
                        City: $city
                        State: $state
                        ZIP: $zip
                        Utility: $utilityProvider
                        Type of project: $projectType
                        Start date: $startDate
                        End date: $endDate
                        Type of building: $buildingType
                        How many rooms: $roomAmount
                        How are rooms used: $roomUseString
                        Additional room details: $roomDetails
                        Quantity/name of products replaced: $quantityProducts
                        Quantity/name of desired products: $quantityDesired
                        Tell us about dehu/hvac equip: $dehuHvac
                        Additional equip details: $additionalDetails
                    """.trimIndent()

                    if (!isABear()) {
                        formLock = false
                        url = webToUrl+myorgid
                        form.action = url
                    }
                    form.submit()
                }
            },
    ) {

        Input(
            type = InputType.Hidden,
            attrs = Modifier
                .toAttrs {
                    attr("name", "oid")
                    attr("value", "00DHp000001scIw")
                }
        )

        Input(
            type = InputType.Hidden,
            attrs = Modifier
                .toAttrs {
                    attr("name", "retURL")
                    attr("value", "https://greenrebates.com")
                }
        )

        //NOTE: These fields are optional debugging elements. Please uncomment
//        Input(
//            type = InputType.Hidden,
//            attrs = Modifier
//                .toAttrs {
//                    attr("name", "debug")
//                    attr("value", "1")
//                }
//        )
//
//        Input(
//            type = InputType.Hidden,
//            attrs = Modifier
//                .toAttrs {
//                    attr("name", "debugEmail")
//                    attr("value", "owen@greenrebates.com")
//                }
//        )
        Div(
            attrs = ResponsiveColumns.toModifier()
                .then(ContactRow.toModifier())
                .toAttrs()
        ) {
            Column(
                modifier = InputColumn.toModifier()
            ) {
                RequiredLabel(forId = "first_name", text = "First Name")
                Input(InputType.Text, attrs = ContactInputStyle.toModifier()
                    .width(100.percent)
                    .toAttrs {
                    id("first_name")
                    name("first_name")
                    maxLength(40)
                    required()
                })
            }

            Column(
                modifier = InputColumn.toModifier()
            ) {
                RequiredLabel(forId = "last_name", text = "Last Name")
                Input(InputType.Text, attrs = ContactInputStyle.toModifier()
                    .width(100.percent)
                    .toAttrs {
                    id("last_name")
                    name("last_name")
                    maxLength(80)
                    required()
                })
            }
        }

        Div(
            attrs = ResponsiveColumns.toModifier()
                .then(ContactRow.toModifier())
                .toAttrs()
        ) {
            Column(
                modifier = InputColumn.toModifier()
            ) {
                RequiredLabel(forId = "email", text = "Email")
                Input(InputType.Text, attrs = ContactInputStyle.toModifier()
                    .width(100.percent)
                    .toAttrs {
                    id("email")
                    name("email")
                    maxLength(80)
                    required()
                })
            }

            Column(
                modifier = InputColumn.toModifier()
            ) {
                Label(forId = "phone", attrs = FormInputLabelStyle.toModifier().toAttrs()) {
                    Text("Phone")
                }
                Input(InputType.Text, attrs = ContactInputStyle.toModifier()
                    .width(100.percent)
                    .toAttrs {
                    id("phone")
                    name("phone")
                    maxLength(40)

                })
            }
        }

        Div(
            attrs = ResponsiveColumns.toModifier()
                .then(ContactRow.toModifier())
                .toAttrs()
        ) {
            Column(
                modifier = InputColumn.toModifier()
            ) {
                Label(forId = "company", attrs = FormInputLabelStyle.toModifier().toAttrs()) {
                    Text("Your Company Name?")
                }
                Input(InputType.Text, attrs = ContactInputStyle.toModifier()
                    .width(100.percent)
                    .toAttrs {
                        id("company")
                        name("company")
                        maxLength(40)
    
                    })
            }

            Column(
                modifier = InputColumn.toModifier()
            ) {
                Label(forId = "00NVb000003bMJB", attrs = FormInputLabelStyle.toModifier().toAttrs()) {
                    Text("Utility Provider?")
                }
                Input(InputType.Text, attrs = ContactInputStyle.toModifier()
                    .width(100.percent)
                    .toAttrs {
                        id("00NVb000003bMJB")
                        name("00NVb000003bMJB")
                        maxLength(50)
                        attr("value", util)
                    })
            }
        }

        H3(attrs = ContactUsSectionHeader.toAttrs()) {
            Text("Tell Us About Your Project")
        }
        P(attrs = ContactUsSectionSubtitle.toModifier().toAttrs()) {
            Text("This will help us get more accurate rebate estimates.")
        }

        Div(
            attrs = ResponsiveColumns.toModifier()
                .then(ContactRow.toModifier())
                .toAttrs()
        ) {
            Column(
                modifier = InputColumn.toModifier()
            ) {
                Label(forId = "00NVb000003bMcX", attrs = FormInputLabelStyle.toModifier().toAttrs()) {
                    Text("Name of your project?")
                }
                Input(InputType.Text, attrs = ContactInputStyle.toModifier()
                    .width(100.percent)
                    .toAttrs {
                    id("00NVb000003bMcX")
                    name("00NVb000003bMcX")
                    maxLength(50)

                })
            }

            Column(
                modifier = InputColumn.toModifier()
            ) {
                Label(forId = "00NVb000003bMW5", attrs = FormInputLabelStyle.toModifier().toAttrs()) {
                    Text("What is your building type?")
                }
                Select(
                    attrs = ContactInputStyle.toModifier()
                        .width(100.percent)
                        .toAttrs {
                            id("00NVb000003bMW5")
                            name("00NVb000003bMW5")
                            attr("title", "What is your building type?")
                        }
                ) {
                    Option("") {
                        Text("--None--")
                    }
                    Option("Indoor") {
                        Text("Indoor")
                    }
                    Option("Greenhouse") {
                        Text("Greenhouse")
                    }
                    Option("Both Indoor and Greenhouse") {
                        Text("Both Indoor and Greenhouse")
                    }
                }
            }
        }

        Div(
            attrs = ResponsiveColumns.toModifier()
                .then(ContactRow.toModifier())
                .toAttrs()
        ) {
            Column(
                modifier = InputColumn.toModifier()
            ) {
                Label(forId = "00NVb000001wlIv", attrs = FormInputLabelStyle.toModifier().toAttrs()) {
                    Text("What type of project is this?")
                }
                Select(
                    attrs = ContactInputStyle.toModifier()
                        .width(100.percent)
                        .toAttrs {
                            id("00NVb000001wlIv")
                            name("00NVb000001wlIv")
                            attr("title", "What type of project is this?")
                        }
                ) {
                    Option("") {
                        Text("--None--")
                    }
                    Option( "New Construction") {
                        Text("New Construction")
                    }
                    Option( "Retrofit") {
                        Text("Retrofit")
                    }
                }
            }

            Column(
                modifier = InputColumn.toModifier()
            ) {
                Label(forId = "00NVb000003bNS9", attrs = FormInputLabelStyle.toModifier().toAttrs()) {
                    Text("How many rooms?")
                }
                Input(InputType.Text, attrs = ContactInputStyle.toModifier()
                    .width(100.percent)
                    .toAttrs {
                        id("00NVb000003bNS9")
                        name("00NVb000003bNS9")

                    })
            }
        }

        Div(
            attrs = ResponsiveColumns.toModifier()
                .then(ContactRow.toModifier())
                .padding(top = 4.px)
                .toAttrs()
        ) {
            Column(modifier = ContactRow.toModifier().gap(16.px)) {
                Column(
                    modifier = InputColumn.toModifier()
                ) {
                    Label(forId = "start_date_picker", attrs = FormInputLabelStyle.toModifier().toAttrs()) {
                        Text("Start Date?")
                    }
                    Input(InputType.Date, attrs = ContactInputStyle.toModifier().width(100.percent)
                        .toAttrs {
                            id("start_date_picker")
                            value(selectedStartDate)
                            onInput {
                                selectedStartDate = it.value
                                val formatted = reformatDate(selectedStartDate)
                                document.getElementById("00NVb000003bM4f")?.setAttribute("value", formatted)
                            }
                        })

                    Input(InputType.Text, attrs = ContactInputStyle.toModifier()
                        .display(DisplayStyle.None)
                        .toAttrs {
                            id("00NVb000003bM4f")
                            name("00NVb000003bM4f")

                        })
                }

                Column(
                    modifier = InputColumn.toModifier()
                ) {
                    Label(forId = "completion_date_picker", attrs = FormInputLabelStyle.toModifier().toAttrs()) {
                        Text("Completion date?")
                    }
                    Input(InputType.Date, attrs = ContactInputStyle.toModifier().width(100.percent)
                        .toAttrs {
                            id("completion_date_picker")
                            value(selectedCompletionDate)
                            onInput {
                                selectedCompletionDate = it.value
                                val formatted = reformatDate(selectedCompletionDate)
                                document.getElementById("00NVb000003bM7t")?.setAttribute("value", formatted)
                            }
                        })


                    Input(InputType.Text, attrs = ContactInputStyle.toModifier()
                        .display(DisplayStyle.None)
                        .toAttrs {
                            id("00NVb000003bM7t")
                            name("00NVb000003bM7t")

                        })
                }
            }

            Column(
                modifier = ContactRow.toModifier()
                    .gap(4.px)
            ) {
                Column(
                    modifier = InputColumn.toModifier()
                ) {
                    Label(forId = "00NVb000003bOHl", attrs = FormInputLabelStyle.toModifier().toAttrs()) {
                        Text("Room use?")
                    }
                    Select(
                        multiple = true,
                        attrs = ContactInputStyle.toModifier()
                            .width(100.percent)
                            .then(roomUseResponsiveStyle.toModifier())
                            .toAttrs {
                                id("00NVb000003bOHl")
                                name("00NVb000003bOHl")
                                attr("title", "How will these rooms be used?")
                            }
                    ) {
                        Option("Vegetative Growth") {
                            Text("Vegetative Growth")
                        }
                        Option("Flowering Growth") {
                            Text("Flowering Growth")
                        }
                        Option("Mother or Clones") {
                            Text("Mother or Clones")
                        }
                        Option("Microgreens") {
                            Text("Microgreens")
                        }
                        Option("Non-Cannabis Agriculture") {
                            Text("Non-Cannabis Agriculture")
                        }
                    }
                }
                Column(
                    modifier = InputColumn.toModifier()
                        .then(RoomUseTutorialStyle.toModifier())
                ) {
                    SpanText("To select multiple, hold", Modifier.lineHeight(16.px).fontWeight(FontWeight.Bold))
                    P(
                        attrs = Modifier
                            .margin(0.px)
                            .fontWeight(FontWeight.Light)
                            .toAttrs()
                    ) {
                        FaWindows(
                            size = IconSize.LG
                        )
                        Text(" : Ctrl")
                        FaApple(
                            size = IconSize.LG,
                            modifier = Modifier
                                .margin(left = 12.px)
                        )
                        Text(" : Command (⌘)")
                    }
                }
            }
        }

        Div(
            attrs = ResponsiveColumns.toModifier()
                .then(ContactRow.toModifier())
                .padding(bottom = 4.px)
                .toAttrs()
        ) {
            Column(
                modifier = InputColumn.toModifier()
            ) {
                Label(forId = "00NVb000003bPQj", attrs = FormInputLabelStyle.toModifier().toAttrs()) {
                    Text("Additional room details?")
                }
                TextArea(attrs = ContactInputStyle.toModifier()
                    .width(100.percent)
                    .resize(Resize.None)
                    .height(54.px)
                    .toAttrs {
                        id("00NVb000003bPQj")
                        name("00NVb000003bPQj")
                        rows(4)
                        attr("wrap", "soft")
                    })
            }
        }

        H3(attrs = ContactUsSectionHeader.toAttrs()) {
            Text("Where Is This Facility Located?")
        }
        P(attrs = ContactUsSectionSubtitle.toModifier().toAttrs()) {
            Text("Please use the address as it appears on the Utility Bill.")
        }

        Div(
            attrs = ResponsiveColumns.toModifier()
                .then(ContactRow.toModifier())
                .toAttrs()
        ) {
            Column(
                modifier = InputColumn.toModifier()
            ) {
                Label(forId = "street", attrs = FormInputLabelStyle.toModifier().toAttrs()) {
                    Text("Street")
                }
                TextArea(attrs = ContactInputStyle.toModifier()
                    .width(100.percent)
                    .resize(Resize.None)
                    .toAttrs {
                        id("street")
                        name("street")
                    })
            }

            Column(
                modifier = InputColumn.toModifier()
            ) {
                Label(forId = "city", attrs = FormInputLabelStyle.toModifier().toAttrs()) {
                    Text("City")
                }
                Input(InputType.Text, attrs = ContactInputStyle.toModifier()
                    .width(100.percent)
                    .toAttrs {
                    id("city")
                    name("city")
                    maxLength(40)

                })
            }
        }

        Div(
            attrs = ResponsiveColumns.toModifier()
                .then(ContactRow.toModifier())
                .toAttrs()
        ) {
            Column(
                modifier = InputColumn.toModifier()
            ) {
                Label(forId = "state", attrs = FormInputLabelStyle.toModifier().toAttrs()) {
                    Text("State/Province")
                }
                Input(InputType.Text, attrs = ContactInputStyle.toModifier()
                    .width(100.percent)
                    .toAttrs {
                        id("state")
                        name("state")
                        maxLength(20)
                        attr("value", state)
                })
            }

            Column(
                modifier = InputColumn.toModifier()
            ) {
                Label(forId = "zip", attrs = FormInputLabelStyle.toModifier().toAttrs()) {
                    Text("Zip")
                }
                Input(InputType.Text, attrs = ContactInputStyle.toModifier()
                    .width(100.percent)
                    .toAttrs {
                    id("zip")
                    name("zip")
                    maxLength(20)

                })
            }
        }

        H3(attrs = ContactUsSectionHeader.toAttrs()) {
           Text("Tell Us About Your Equipment")
        }
        P(attrs = ContactUsSectionSubtitle.toModifier().toAttrs()) {
            Text("Any information about your current or future equipment is appreciated.")
        }

        Div(
            attrs = ResponsiveColumns.toModifier()
                .then(ContactRow.toModifier())
                .toAttrs()
        ) {
            Column(
                modifier = InputColumn.toModifier()
            ) {
                Label(forId = "00NVb000003bOo1", attrs = FormInputLabelStyle.toModifier().toAttrs()) {
                    Text("Quantity and name of products being replaced:")
                }
                TextArea(attrs = ContactInputStyle.toModifier()
                    .width(100.percent)
                    .resize(Resize.None)
                    .height(54.px)
                    .toAttrs {
                    id("00NVb000003bOo1")
                    name("00NVb000003bOo1")
                    rows(3)
                    attr("wrap", "soft")
                })
            }
        }

        Div(
            attrs = ResponsiveColumns.toModifier()
                .then(ContactRow.toModifier())
                .toAttrs()
        ) {
            Column(
                modifier = InputColumn.toModifier()
            ) {
                Label(forId = "00NVb000003bHpn", attrs = FormInputLabelStyle.toModifier().toAttrs()) {
                    Text("Quantity and name of desired products:")
                }
                TextArea(attrs = ContactInputStyle.toModifier()
                    .width(100.percent)
                    .resize(Resize.None)
                    .height(54.px)
                    .toAttrs {
                    id("00NVb000003bHpn")
                    name("00NVb000003bHpn")
                    rows(3)
                    attr("wrap", "soft")
                })
            }
        }

        Div(
            attrs = ResponsiveColumns.toModifier()
                .then(ContactRow.toModifier())
                .toAttrs()
        ) {
            Column(
                modifier = InputColumn.toModifier()
            ) {
                Label(forId = "00NVb000003bQ0D", attrs = FormInputLabelStyle.toModifier().toAttrs()) {
                    Text("Tell us about your Dehu/HVAC equipment:")
                }
                Select(
                    attrs = InputStyleHalf.toModifier()
                        .width(100.percent)
                        .toAttrs {
                        id("00NVb000003bQ0D")
                        name("00NVb000003bQ0D")
                        attr("title", "Tell us about your Dehu/HVAC equipment")
                    }
                ) {
                    Option("") {
                        Text("--None--")
                    }
                    Option("We will be purchasing new Dehu/HVAC") {
                        Text("We will be purchasing new Dehu/HVAC")
                    }
                    Option("We will be replacing old Dehu/HVAC") {
                        Text("We will be replacing old Dehu/HVAC")
                    }
                    Option("We currently have Dehu/HVAC") {
                        Text("We currently have Dehu/HVAC")
                    }
                    Option("This does not apply to my project") {
                        Text("This does not apply to my project")
                    }
                }
            }
        }

        Div(
            attrs = ResponsiveColumns.toModifier()
                .then(ContactRow.toModifier())
                .toAttrs()
        ) {
            Column(
                modifier = InputColumn.toModifier()
            ) {
                Label(forId = "00NVb000003bQcv", attrs = FormInputLabelStyle.toModifier().toAttrs()) {
                    Text("Additional equipment details?")
                }
                TextArea(attrs = ContactInputStyle.toModifier()
                    .width(100.percent)
                    .resize(Resize.None)
                    .height(54.px)
                    .toAttrs {
                    id("00NVb000003bQcv")
                    name("00NVb000003bQcv")
                    rows(4)
                    attr("wrap", "soft")
                })
            }
        }

        /* Hidden Elements */
        TextArea(attrs = InputStyleHalf.toModifier()
            .display(DisplayStyle.None)
            .toAttrs {
                id("00NVb000003d57l")
                name("00NVb000003d57l")
            })

        Select(
            attrs = InputStyleHalf.toModifier()
                .display(DisplayStyle.None)
                .toAttrs {
                    id("lead_source")
                    name("lead_source")
                }
        ) {
            Option(leadSource) {
                Text(leadSource)
            }
        }

        Column(
            modifier = InputColumn.toModifier()
                .padding(top = 4.px),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {
            Button(
                attrs = ButtonHoverDarkGreen.toModifier()
                    .classNames("w-100", "fs-5", "mt-3", "px-3", "py-3", "shadow")
                    .border(1.px, LineStyle.Solid, Colors.LightGray)
                    .borderRadius(8.px)
                    .toAttrs {
                        type(ButtonType.Submit)
                    }
            ) {
                Text("Send Message")
            }
            SpanText(
                text = "By submitting this form, you are consenting to receive marketing emails from Green Rebates.",
                modifier = Modifier
                    .padding(top = 8.px)
                    .textAlign(TextAlign.Center)
                    .fontWeight(FontWeight.Light)
            )
        }
    }
}


//<!--  ----------------------------------------------------------------------  -->
//<!--  NOTE: Please add the following <META> element to your page <HEAD>.      -->
//<!--  If necessary, please modify the charset parameter to specify the        -->
//<!--  character set of your HTML page.                                        -->
//<!--  ----------------------------------------------------------------------  -->
//<META HTTP-EQUIV="Content-type" CONTENT="text/html; charset=UTF-8">
//<!--  ----------------------------------------------------------------------  -->
//<!--  NOTE: Please add the following <FORM> element to your page.             -->
//<!--  ----------------------------------------------------------------------  -->
//<form action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00DHp000001scIw" method="POST">
//<input type=hidden name="oid" value="00DHp000001scIw">
//<input type=hidden name="retURL" value="http://greenrebates.com">
//<!--  ----------------------------------------------------------------------  -->
//<!--  NOTE: These fields are optional debugging elements. Please uncomment    -->
//<!--  these lines if you wish to test in debug mode.                          -->
//<!--  <input type="hidden" name="debug" value=1>                              -->
//<!--  <input type="hidden" name="debugEmail" value="matt@greenrebates.com">   -->
//<!--  ----------------------------------------------------------------------  -->
//<label for="first_name">First Name</label><input  id="first_name" maxlength="40" name="first_name" size="20" type="text" /><br>
//<label for="last_name">Last Name</label><input  id="last_name" maxlength="80" name="last_name" size="20" type="text" /><br>
//<label for="email">Email</label><input  id="email" maxlength="80" name="email" size="20" type="text" /><br>
//<label for="phone">Phone</label><input  id="phone" maxlength="40" name="phone" size="20" type="text" /><br>
//<label for="company">Company</label><input  id="company" maxlength="40" name="company" size="20" type="text" /><br>
//What is the name of your project?:<input  id="00NVb000003bMcX" maxlength="50" name="00NVb000003bMcX" size="20" type="text" /><br>
//<label for="street">Street</label><textarea name="street"></textarea><br>
//<label for="city">City</label><input  id="city" maxlength="40" name="city" size="20" type="text" /><br>
//<label for="state">State/Province</label><input  id="state" maxlength="20" name="state" size="20" type="text" /><br>
//<label for="zip">Zip</label><input  id="zip" maxlength="20" name="zip" size="20" type="text" /><br>
//Who is your Utility Provider?:<input  id="00NVb000003bMJB" maxlength="50" name="00NVb000003bMJB" size="20" type="text" /><br>
//What type of project is this?:<select  id="00NVb000001wlIv" name="00NVb000001wlIv" title="What type of project is this?"><option value="">--None--</option><option value="New Construction">New Construction</option>
//<option value="Retrofit">Retrofit</option>
//</select><br>
//When do you plan to start your Project?:<span class="dateInput dateOnlyInput"><input  id="00NVb000003bM4f" name="00NVb000003bM4f" size="12" type="text" /></span><br>
//What is your expected completion date?:<span class="dateInput dateOnlyInput"><input  id="00NVb000003bM7t" name="00NVb000003bM7t" size="12" type="text" /></span><br>
//What is your building type?:<select  id="00NVb000003bMW5" name="00NVb000003bMW5" title="What is your building type?"><option value="">--None--</option><option value="Indoor">Indoor</option>
//<option value="Greenhouse">Greenhouse</option>
//<option value="Both Indoor and Greenhouse">Both Indoor and Greenhouse</option>
//</select><br>
//How many rooms will this project have?:<input  id="00NVb000003bNS9" name="00NVb000003bNS9" size="20" type="text" /><br>
//How will these rooms be used?:<select  id="00NVb000003bOHl" multiple="multiple" name="00NVb000003bOHl" title="How will these rooms be used?"><option value="Vegetative Growth">Vegetative Growth</option>
//<option value="Flowering Growth">Flowering Growth</option>
//<option value="Mothers or Clones">Mothers or Clones</option>
//<option value="Microgreens">Microgreens</option>
//<option value="Non-Cannabis Agriculture">Non-Cannabis Agriculture</option>
//</select><br>
//Additional room details?:<textarea  id="00NVb000003bPQj" name="00NVb000003bPQj" rows="4" type="text" wrap="soft"></textarea><br>
//Qty and name of products being replaced::<textarea  id="00NVb000003bOo1" name="00NVb000003bOo1" rows="3" type="text" wrap="soft"></textarea><br>
//Qty and name of desired products::<textarea  id="00NVb000003bHpn" name="00NVb000003bHpn" rows="3" type="text" wrap="soft"></textarea><br>
//Tell us about your Dehu/HVAC equipment:<select  id="00NVb000003bQ0D" name="00NVb000003bQ0D" title="Tell us about your Dehu/HVAC equipment"><option value="">--None--</option><option value="We will be purchasing new Dehu/HVAC">We will be purchasing new Dehu/HVAC</option>
//<option value="We will be replacing old Dehu/HVAC">We will be replacing old Dehu/HVAC</option>
//<option value="We currently have Dehu/HVAC">We currently have Dehu/HVAC</option>
//<option value="This does not apply to my project">This does not apply to my project</option>
//</select><br>
//Additional equipment details?:<textarea  id="00NVb000003bQcv" name="00NVb000003bQcv" rows="4" type="text" wrap="soft"></textarea><br>
//<label for="lead_source">Lead Source</label><select  id="lead_source" name="lead_source"><option value="">--None--</option><option value="Direct">Direct</option>
//<option value="Partner">Partner</option>
//<option value="Seinergy">Seinergy</option>
//<option value="Ambassador">Ambassador</option>
//<option value="Affiliate">Affiliate</option>
//<option value="External Referral">External Referral</option>
//<option value="Employee Referral">Employee Referral</option>
//<option value="Advertisement">Advertisement</option>
//<option value="Social Media">Social Media</option>
//<option value="Web">Web</option>
//<option value="Word of mouth">Word of mouth</option>
//<option value="Trade Show">Trade Show</option>
//<option value="Other">Other</option>
//<option value="New Partner Registration">New Partner Registration</option>
//<option value="MJBIZ 2024">MJBIZ 2024</option>
//<option value="Cannabiz Media List">Cannabiz Media List</option>
//</select><br>
//<input type="submit" name="submit">
//</form>